import { render, staticRenderFns } from "./autoopeningtimes.vue?vue&type=template&id=7b87e2b5&scoped=true&"
import script from "./autoopeningtimes.vue?vue&type=script&lang=js&"
export * from "./autoopeningtimes.vue?vue&type=script&lang=js&"
import style0 from "./autoopeningtimes.vue?vue&type=style&index=0&id=7b87e2b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b87e2b5",
  null
  
)

export default component.exports